function splitHeadingByBr(element) {
    const doc = element.ownerDocument
    const lines = []
    let current = doc.createDocumentFragment()

    function processNodes(nodes, activeWrapper = null) {
        for (const node of [...nodes]) {
            if (node.nodeName === "BR") {
                if (activeWrapper?.childNodes.length) {
                    current.appendChild(activeWrapper)
                }

                lines.push(current)
                current = doc.createDocumentFragment()
                activeWrapper = null
                continue
            }

            if (node.nodeType === Node.TEXT_NODE) {
                ;(activeWrapper ?? current).appendChild(node.cloneNode())
                continue
            }

            if (!node.querySelector("br")) {
                ;(activeWrapper ?? current).appendChild(node.cloneNode(true))
                continue
            }

            const wrapper = node.cloneNode(false)
            processNodes(node.childNodes, wrapper)

            if (wrapper.childNodes.length) {
                current.appendChild(wrapper)
            }
        }

        if (activeWrapper?.childNodes.length) {
            current.appendChild(activeWrapper)
        }
    }

    processNodes(element.childNodes)

    if (current.childNodes.length) {
        lines.push(current)
    }

    return lines.filter((line) => line.childNodes.length > 0)
}

function rebuildThreeLineHeading(heading, lines) {
    const doc = heading.ownerDocument
    heading.innerHTML = ""
    heading.classList.add("banner-image-new__title--3-lines")

    lines.forEach((line, index) => {
        if (index === 1) {
            heading.appendChild(doc.createElement("br"))

            const span = doc.createElement("span")
            span.className = "banner-image-new__title-line--indent"
            span.appendChild(line)
            heading.appendChild(span)
            return
        }

        heading.appendChild(line)
    })
}

function isThreeLineTitleProcessed(heading) {
    if (!heading.classList.contains("banner-image-new__title--3-lines")) {
        return false
    }

    if (heading.querySelectorAll(".banner-image-new__title-line--indent").length !== 1) {
        return false
    }

    return heading.querySelectorAll("br").length === 1
}

function processBannerHeading(heading) {
    if (heading.querySelectorAll("br").length !== 2 && !heading.classList.contains("banner-image-new__title--3-lines")) {
        return
    }

    if (isThreeLineTitleProcessed(heading)) {
        return
    }

    const lines = splitHeadingByBr(heading)

    if (lines.length !== 3) {
        return
    }

    rebuildThreeLineHeading(heading, lines)
}

export function initBannerImageNewTitles(root = document) {
    root.querySelectorAll(".banner-image-new h1, .banner-image-new h2").forEach(processBannerHeading)
}

initBannerImageNewTitles()
